module.exports = __webpack_public_path__ + "img/backrgound.16aa3df5.png";